<emm-management-layout>
  <emm-progress-bar [isLoading$]="anyLoading$"></emm-progress-bar>
  <emm-search-filter
    [addDialog]="false"
    [attr.data-testid]="'item_groupings_search_bar'"
    [displaySearchWithOptions]="false"
    [fields]="fields"
    [isAdminOrAuthor]="(this.isAdmin || this.isAuthor) && !isMMSAuthor"
    [isSuperAdmin]="this.isSuperAdmin"
    layout-center-header
    (filter)="onFilter($event)"
  ></emm-search-filter>
  <emm-generic-items-tree
    [contextMenuActions]="itemGroupingsContextMenuActions"
    [disableContextActions]="centerLoading$ | async"
    [disableDefaultOnMove]="true"
    [items]="nodes$ | async"
    layout-center-content
    [options]="options"
    [readonly]="(isReadOnly$ | async) || isMMSAuthor"
    [isMmsAuthorOnly]="isMMSAuthor"
  ></emm-generic-items-tree>
  @if ((itemDetail$ | async); as item) {
    <emm-management-attributes-header
      layout-right-header
      [name]="item.name"
      [tag]="item.tag"
      [type]="item.itemType"
    ></emm-management-attributes-header>
  }
  @if ((itemDetail$ | async); as item) {
    <emm-items-form
      #form
      layout-right-content
      [selectedItem]="item"
    ></emm-items-form>
  }
</emm-management-layout>
